<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <!--返回上一层-->
      <span class="topT">非会员订单查询</span>
      <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <br />

    <div style=" width:100% " align="center" v-show="  IsLoading  ">
      <img src="../../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto" />
      <div style="margin-top:0.5rem">
        登陆中...
      </div>
    </div>

    <div class="bigpage" v-show="  !IsLoading  ">

      <div align="left" style="margin-top:2vh">
        <!--<mu-divider class="dividerClass"/>-->
        <mu-text-field hintText="请输入手机号或邮箱" type="text" icon="smartphone" v-model="UserPhone" fullWidth="" style="margin-left:-4% ; width:103% " />
        <nobr>
          <!--图片附加码-->
          <mu-text-field hintText="请输入附加码" type="text" icon="vpn_key" v-model="FJM1" style="margin-left:-4% ; width:69% " />
          <!--<img v-bind:src="TPFJM" style="width:27% ; margin-left:2% ; margin-bottom:-2%" v-on:click="this.getValidateCode" align="right" />-->
          <img v-bind:src="TPFJM" style="width:30% ;  margin-left:2% ; float:right;  margin-top: -0.1rem " v-on:click="this.getValidateCode" />

        </nobr>

        <nobr>
          <mu-text-field hintText="请输入动态密码" type="text" icon="verified_user" v-model="YZM" style="margin-left:-4% ; width:69% ; z-index: 1" class="txtValidate" />

          <!--<mu-text-field hintText="请输入动态密码" type="text" icon="verified_user" v-model="YZM" style="margin-left:-4% ; width:74% " />-->
          <span v-on:click="getYZM" v-show="haveYZM == false">
            <input type="button" value="获取" style="font-size:0.32rem ; float:right;   background-color:#27ba69 ; height: 0.7rem  ; border:none  ;  width: 30% ;  color:white" />
          </span>
          <span v-show="haveYZM == true">
            <input type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right;   background-color:#eeeeee ;   height: 0.7rem  ; border:none  ;  width: 30% ; color:#999 ;" />
          </span>
        </nobr>
      </div>

      <mu-raised-button label="查 询" primary="" @click="QueryOrderWithoutLogin" v-bind:style="{ width:'100%', height:'0.8rem' }" style="font-size: 0.3rem ; margin-top:0.2rem " />

      <!--快捷登录  end-->

      <!--下方通用-->
      <br />
      <br />
      <router-link slot="left" to="/user/Login" style="font-size:0.3rem ;  color:#FF8F3B  ; ">
        已有账号？直接登录
      </router-link>

      <br />
      <br />
      <br />
      <br />

    </div>

    <!--下方通用  END-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>



<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {

    return {

      IsLoading: false,



      TPFJM: '',

      //  输入框初始化 2 
      UserPhone: '',
      FJM1: '',
      YZM: '',
      //  输入框初始化  END  2 


      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END

      haveYZM: false,
      WaitTime: '',
      Time: 29,


    }
  },
  //进入时运作
  activated() {
    // this.FJM1 = '';

    // if (this.UserPhone != '' && this.YZM != '') {
    //   this.QueryOrderWithoutLogin();
    // }

    this.UserPhone = '';
    this.FJM1 = '';
    this.YZM = '';

    this.getValidateCode()
  },
  // 数据获取
  computed: {
    ...mapGetters([
      'g_UserInfo',
    ])
  },
  methods: {
    ...mapMutations([
      'setG_UserInfo',
    ]),

    // 图片验证码
    getValidateCode() {
      // 用户已登录
      if (this.g_UserInfo.Card_no) {
        console.log(this.g_UserInfo)
        this.$router.push({ path: '/user/UserCenter' });
      }
      this.TPFJM = api.getValidateCode();
    },


    //  获取验证码
    getYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.FJM1 == '') {
        this.TellUser = '请输入附加码';
        this.showToast();
      }
      else {

        var type = 'EMAIL';
        if (this.UserPhone.indexOf('@') == -1) {
          type = 'PHONE';
        }

        // 开始计时
        this.haveYZM = true;
        this.WaitTime = this.Time + "秒"
        this.timer();

        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('captcha', this.FJM1);
        params.append('queryType', type);

        this.$http.post(api.SMSQueryOrder(), params.toParam()).then((res) => {

          console.log(res)
          if (res.Result == true) {
            this.TellUser = res.Data;
            this.showToast();
          }
          else {  //  获取失败
            this.TellUser = res.Message;
            this.showToast();
            this.FJM = '';

            this.getValidateCode();

            this.Time = 5;
            
          }
        })
      }
    },
    timer() {
      if (this.Time > 0) {
        this.Time--;
        this.WaitTime = this.Time + "秒"

        setTimeout(this.timer, 1000);
      }
      else if (this.Time == 0) {
        this.haveYZM = false;
        this.Time = 29;
      }
    },
    //  获取验证码  END








    //  其他用户登录
    QueryOrderWithoutLogin() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号';
        this.showToast();
      }
      else if (this.YZM == '') {
        this.TellUser = '请输入动态密码';
        this.showToast();
      }
      else {

        this.IsLoading = true;


        var params = new this.URLSearchParam();
        params.append('phoneNo', this.UserPhone);
        params.append('validateCode', this.YZM);
        params.append('pageIndex', 1);
        params.append('PageSize', 10);

        //  快捷登录
        this.$http.post(api.QueryOrderWithoutLogin(), params.toParam()).then((res) => {
          console.log(res)
          if (res.Result == true) {
            var result = res.Data;
            // 保存登录信息

            var UserInfo = this.g_UserInfo;

            UserInfo.IsOtherUser = true;
            UserInfo.OtherUserID = this.UserPhone;
            UserInfo.YZM = this.YZM;

            this.setG_UserInfo(UserInfo);
            console.log(this.g_UserInfo);

            this.$router.push({ path: '/home/IndexToOther' });

          }
          else {  //登陆失败

            this.TellUser = res.Message;
            this.showToast();

          }
          this.IsLoading = false;

        })

      }
    },
    //  快捷登录  END













    // 弹出层
    showToast() {
      console.log(this.TellUser)
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录' || this.TellUser == '验证码过期' || this.TellUser == '服务器错误') {
        this.$store.dispatch('clearUser');



        setTimeout(() => { this.$router.push({ path: '/user/OtherUser' }); }, 1200)
      }
      if (this.TellUser == '已登录') {
        setTimeout(() => { this.$router.push({ path: '/home/order' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否





    // 后退一页
    goback() {
      javascript: history.go(-1);
    }

  }
}



</script>





<style lang="less" scoped>
@import "../../../assets/theme.less"; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;


  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor ;
  }

  .Black {
    color: @primaryBlack ;
  }

  .Grey {
    color: @textColor ;
  }
}
</style>






// WEBPACK FOOTER //
// OtherUser.vue?9b924e02